<template>
  <div class="content">
    <div class="days-risk">
      <!-- <div class="p-time">监测时间：{{ $moment(riskShort.ddatetime).format('YYYY-MM-DD HH:mm')}}</div> -->
      <div class="risk-list">
        <div class="risk-item">
          <span>要素/日期</span>
          <span
            v-for="(item, index) in riskResult.times"
            :key="index + ''"
            v-html="item"
          ></span>
        </div>
        <div class="risk-item">
          <span>舒适度</span>
          <span
            v-for="(quality, index) in riskResult.index"
            :key="'quality' + index"
            class="custom-item"
          >
            {{ quality }}
          </span>
        </div>
        <div class="risk-item">
          <span>温湿指数</span>
          <span
            v-for="(pollutant, index) in riskResult.wsIndex"
            :key="'pollutant' + index"
          >
            {{ pollutant }}
          </span>
        </div>
        <div class="risk-item">
          <span>着衣指数</span>
          <span
            v-for="(pollutant, index) in riskResult.zyIndex"
            :key="'pollutant' + index"
            class="custom-item"
          >
            {{ pollutant }}
          </span>
        </div>
        <div class="risk-item">
          <span>风效指数</span>
          <span
            v-for="(pollutant, index) in riskResult.fxIndex"
            :key="'pollutant' + index"
          >
            {{ pollutant }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  props: ["params", "forecastType"],
  data() {
    return {
      riskType: 0,
      riskShort: {},
      riskFore: {},
    };
  },

  watch: {
    countyOccupantResult() {
      setTimeout(() => {
        this.getRiskData();
      }, 100);
    },
    tqskDateResult: {
      handler() {
        setTimeout(() => {
          this.getRiskData();
        }, 100);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("home", [
      "objsList",
      "activeCountyId",
      "cartData",
      "countyOccupantResult",
    ]),
    riskResult() {
      const DEFAULT_RESULT = {
        times: [],
        index: [],
        wsIndex: [],
        zyIndex: [],
        fxIndex: [],
      };

      try {
        // 1. 安全获取 result（避免深拷贝副作用）
        const result = this.riskFore;
        if (!result || !result.data) {
          return DEFAULT_RESULT;
        }
        // 2. 查找当前区县
        const index = this.objsList.findIndex(
          (item) => item.id === this.activeCountyId,
        );
        const county = this.objsList[index].county;

        const countyResult = result.data[county] || {};
        console.log("result", result);

        // 3. 返回结构化数据
        return {
          times: result.dates || [],
          index: countyResult.index || [],
          wsIndex: countyResult.wsIndex || [],
          zyIndex: countyResult.zyIndex || [],
          fxIndex: countyResult.fxIndex || [],
        };
      } catch (e) {
        console.error("[riskResult] 计算失败:", e);
        return DEFAULT_RESULT;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.getRiskData();
    }, 100);
  },
  methods: {
    ...mapMutations("home", ["changeCartItem"]),
    /**
     * 旅游气候舒适度
     */
    async getRiskData() {
      this.riskFore = this.countyOccupantResult;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.8vw 1.04vw 1.04vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;

  .short-risk {
    height: 100%;
    // padding: 10% 8% 4% 8%;
    // padding: 3.13vw 1.04vw 1.04vw 1.04vw;
    box-sizing: border-box;
  }

  .days-risk {
    height: 100%;
    // padding: 10% 8% 4% 8%;
    // padding: 3.13vw 1.04vw 1.04vw 1.04vw;
    box-sizing: border-box;
    // width: 38.31rem;
  }

  .risk-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .risk-item {
      font-size: 0.88rem;
      color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 0.8889vh;

      &:hover {
        cursor: pointer;
      }

      span:nth-child(1) {
        text-align: center;
        width: 6.64vw;
      }

      span {
        width: 74px;
        display: inline-block;
        text-align: center;
        margin: 0vw 0.16vw;
        white-space: nowrap;
        i {
          display: inline-block;
          position: relative;
          width: 3.27rem;
          height: 0.63rem;
          //background: #295073;
          background: #3a678f;
          border-radius: 0.31rem;

          &:hover {
            .pounp {
              display: block;
            }
          }

          .pounp {
            display: none;
            position: absolute;
            bottom: 0.8vw;
            left: 50%;
            transform: translateX(-50%);
            width: 3.27rem;
            height: 1.36vw;
            line-height: 1.36vw;
            background: #052c4d;
            color: #fff;
            box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;

            &::after {
              content: "";
              display: inline-block;
              position: absolute;
              left: 50%;
              bottom: -10px;
              transform: translateX(-50%);
              border: 5px solid transparent;
              border-top-color: rgba(255, 255, 255, 0.8);
              box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            }
          }
        }
      }
      .custom-item {
        white-space: wrap;
      }
    }

    .risk-item:nth-child(1) {
      height: 2.14vw;
      background: #052c4d;
      border-radius: 0.21vw;
    }
  }
}
</style>
